import IEcharts from './full.vue';

export default IEcharts;



//////////////////
// WEBPACK FOOTER
// ./~/vue-echarts-v3/src/full.js
// module id = 1179
// module chunks = 0